export default __webpack_public_path__ + "images/f067cb0b17cfcfa3d2955f1ca7eaad44.png";